import { AutoComplete, Button, Form, Input, Modal, Spin } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import { EditOutlined } from "@ant-design/icons";
import TopHeading from "./TopHeading";
import Empty from "../common/Empty";
import AddServiceLocation from "./AddServiceLocation";
import { debounce } from "lodash";

const ServiceLocationList = () => {
  const [status, setStatus] = useState("");
  const [limit, setLimit] = useState(16);
  const [key, setKey] = useState("");

  const [locationData, setLocationData] = useState({
    loading: false,
    data: null,
  });

  const [locationOptions, setLocationOptions] = useState({
    loading: false,
    list: [],
  });

  const [selectedLocationForEdit, setSelectedLocationForEdit] =
    useState(undefined);
  const [visible, setVisible] = useState(undefined);

  const [form] = Form.useForm();
  const loc = useLocation();

  const reseAllFieldData = () => {
    setStatus("");
    form.resetFields();
  };

  const getServiceLocation = useCallback(async () => {
    setLocationData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
    axios
      .get(
        `${encodedUri}/admin/service-location/all` +
          (key ? `?name=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setLocationData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setLocationData({ loading: false, data: [] });
        console.error("Locations: Error", err);
      });
  }, [key]);
  //

  const getLocationOptions = useCallback(async (key) => {
    setLocationOptions({ loading: true, list: null });
    const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
    return axios
      .get(
        `${encodedUri}/admin/service-location/all` +
          (key ? `?name=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setLocationOptions({
          loading: false,
          list: res.data?.serviceLocations?.map((location) => ({
            label: location.name,
            value: location.name,
          })),
        });
      })
      .catch((err) => {
        setLocationOptions({ loading: false, list: [] });
        console.error("Locations: Error", err);
      });
  }, []);

  const fetchRef = useRef(0);
  const debounceLocationOptionsFetcher = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      getLocationOptions(value);
    };

    return debounce(loadOptions, 800);
  }, [getLocationOptions]);

  useEffect(() => {
    if (visible) {
      setSelectedLocationForEdit(undefined);
    }
  }, [selectedLocationForEdit, visible]);

  useEffect(() => {
    setSelectedLocationForEdit(undefined);
  }, [visible]);

  useEffect(() => {
    getServiceLocation();
    getLocationOptions("");
  }, [getServiceLocation, getLocationOptions]);

  const onClose = () => {
    setSelectedLocationForEdit(null);
    getServiceLocation();
  };

  return (
    <React.Fragment>
      <TopHeading
        {...locationData?.data?.totalElements}
        refetch={getServiceLocation}
      />
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item name="search">
            <AutoComplete
              style={{ width: 250 }}
              onSearch={debounceLocationOptionsFetcher}
              onSelect={(val) => setKey(val.toString())}
              options={locationOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                locationOptions?.loading ? <Spin size="small" /> : null
              }
            >
              <Input.Search
                placeholder="Search by Name"
                onSearch={(val) => setKey(val)}
                enterButton
                loading={locationOptions.loading}
              />
            </AutoComplete>
          </Form.Item>
        </Form>

        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Service Location</span>
                  </div>

                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {locationData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {locationData?.data?.serviceLocations?.length ? (
                    locationData?.data?.serviceLocations?.map(
                      (location: any, index: any) => (
                        <React.Fragment key={index}>
                          <div className="single-product-wrapper">
                            <div className="single-product">
                              <span className="name">{location?.name}</span>
                            </div>
                            <div className="single-product">
                              <button
                                className="btn btn-sm btn-warning mx-1"
                                onClick={() =>
                                  setSelectedLocationForEdit(location)
                                }
                              >
                                <EditOutlined />
                              </button>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Locations" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Modal
            title="Add Location"
            visible={selectedLocationForEdit}
            onCancel={onClose}
            okText={`Submit`}
            // footer={false}
          >
            <AddServiceLocation
              visibleData={selectedLocationForEdit}
              onCloseMethod={onClose}
            />
          </Modal>

          <PaginationTwo
            {...locationData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ServiceLocationList;
